/**
 * Currency domain service.
 * Pure functions - no React imports, no side effects.
 */

import type {CurrencyCode} from "./currency.types";
import {NON_EU_CURRENCIES} from "./currency.types";
import type {CurrencyFilterParams} from "./currency.types";

/**
 * Filters currencies by payment provider.
 * Stripe only supports EU currencies; other providers support all.
 *
 * @param params - currencies and provider
 * @returns filtered currency codes
 */
export function filterCurrenciesByProvider(params: CurrencyFilterParams): CurrencyCode[] {
  const {currencies, provider} = params;

  if (provider === "stripe") {
    const nonEuSet = new Set(NON_EU_CURRENCIES);
    return currencies.filter((c) => !nonEuSet.has(c));
  }

  return currencies;
}
